var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.20178 3.5303L5.99998 5.9291L10.7982 3.5303C10.7804 3.22457 10.6464 2.9372 10.4237 2.72704C10.2009 2.51688 9.90623 2.39985 9.59998 2.3999H2.39998C2.09373 2.39985 1.79905 2.51688 1.57629 2.72704C1.35353 2.9372 1.21954 3.22457 1.20178 3.5303Z",
    fill: "#9CA2AD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8 4.87085L6 7.27085L1.2 4.87085V8.40005C1.2 8.71831 1.32643 9.02353 1.55147 9.24858C1.77651 9.47362 2.08174 9.60005 2.4 9.60005H9.6C9.91826 9.60005 10.2235 9.47362 10.4485 9.24858C10.6736 9.02353 10.8 8.71831 10.8 8.40005V4.87085Z",
    fill: "#9CA2AD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmail);
export default __webpack_public_path__ + "static/media/icon-email.971408df.svg";
export { ForwardRef as ReactComponent };